module.exports = __webpack_public_path__ + "static/arc-plot-6853a6edaf64a71a8feb15bf9bd99a46.png";